import React, { useContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import {
  setCommunityCurrentChannel,
  setChannelMessageList,
  setShowAllThreads,
} from "../../../../../redux/actions";
import { useRouter } from "next/router";
import {
  Modal,
  Popover,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Tooltip,
} from "@mui/material";
import { CommonContext } from "../../../../../../components/helper/commonContext";
import {
  Link,
  Box,
  Typography,
  Button,
  Slide,
  List,
  ListItem,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import {
  setShowThread,
  setThreadDetails,
} from "../../../../../redux/slices/community";
import { useMutation } from "react-query";
import fetcher from "../../../../../dataProvider";
import moment from "moment";
import {
  setSelectedThread,
  setDisplayRightPinnedThread,
  setRightPinnedThreadDetails,
  setUnreadMessageNotifications,
  setThreadUnreadNotifications,
} from "../../../../../redux/slices/community";
import ObjectIconImg from "../../ObjectIconImg";
import Image from "next/image";
import { getCommunityUnreadMessagCountList } from "./api";
import auth from "../../../../../../components/Layout/util/auth";
import { songPageGTMCTAClick } from "../../../../../../util/gtmutil";

const useStyles = makeStyles((theme) => ({
  modalContainer: {
    padding: "30px 15px",
    "& p": {
      fontSize: "16px",
      fontWeight: "500",
      color: "#404040",
      width: "100%",
      linHeight: "24px",
      textAlign: "center",
      marginBottom: "33px",
    },
  },
  popupTitle: {
    paddingBottom: "16px",
    borderBottom: "1px solid rgba(0, 0, 0, 0.2)",
    fontSize: "20px !important",
    fontWeight: "600",
    color: "#000",
    width: "100%",
    marginBottom: "8px",
  },
  btnClose: {
    position: "absolute",
    display: "inline-block",
    top: "25px",
    right: "10px",
    cursor: "pointer",
  },
  btnSearch: {
    position: "absolute",
    display: "flex",
    alignItems: "center",
    top: "22px",
    right: "50px",
    height: "38px",
    cursor: "pointer",
  },
  inputContainer: {
    position: "relative",
    display: "block",
    overflow: "hidden",
    marginRight: "10px",
    "& input": {
      fontSize: "14px",
    },
  },
  contentContainer: {
    position: "relative",
    display: "block",
    marginTop: "29px",
    textAlign: "center",
    "& img": {
      marginBottom: "11px",
    },
    "& h4": {
      fontSize: "24px",
      fontWeight: "600",
      color: "#000",
      textAlign: "center",
      marginBottom: "11px",
    },
  },
  btnCreateThread: {
    position: "relative",
    textAlign: "center",
    display: "block",
    fontSize: "16px",
    fontWeight: "600",
    width: "100%",
    maxWidth: "180px",
    background: "linear-gradient(90deg,#E14084,#3454FA,#54B5BB)",
    borderRadius: "8px",
    height: "44px",
    margin: "0 auto",
    color: "#fff !important",
    textDecoration: "none",
    textTransform: "capitalize !important",
    marginTop: "30px !important",
  },
  threadList: {
    position: "relative",
    display: "block",
    width: "100%",
    padding: "0 !important",
    marginBottom: "60px",
    maxHeight: "250px",
    overflow: "auto",
    "& > li": {
      position: "relative",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      padding: "0",
      padding: "10px",
      background: "#F4F5FD",
      borderRadius: "8px",
    },
  },
  threadTitle: {
    position: "relative",
    display: "flex",
    alignItems: "center",
    marginBottom: "7px",
    width: "100%",
    "& img": {
      margin: "0",
    },
    "& h5": {
      fontSize: "14px",
      fontWeight: "600",
      margin: "0 12px 0 5px",
      "@media(max-width:480px)": {
        whiteSpace: "nowrap",
      },
    },
    "& span": {
      fontSize: "12px",
      fontWeight: "600",
      color: "#E14084",
      "@media(max-width:480px)": {
        whiteSpace: "nowrap",
      },
    },
  },
  threadCreatedBy: {
    position: "relative",
    display: "flex",
    alignItems: "center",
    width: "100%",
    "& img": {
      margin: "0",
    },
    "& h5": {
      fontSize: "12px",
      fontWeight: "600",
      margin: "0 12px 0 5px",
    },
    "& span": {
      fontSize: "12px",
      fontWeight: "600",
      color: "#707174",
      margin: "0 12px 0 0",
    },
    "@media(max-width:767px)": {
      flexWrap: "wrap",
      paddingLeft: "30px",
      wordBreak: "break-word",
      "& h5": {
        marginTop: "7px",
      },
      "& span": {
        marginTop: "7px",
      },
    },
    "@media(max-width:480px)": {
      paddingLeft: "0",
      "& h5": {
        marginLeft: "0",
      },
    },
  },
  thumbListContainer: {
    position: "relative",
    display: "flex",
    alignItems: "center",
  },
  thumbList: {
    position: "relative",
    display: "flex",
    width: "100%",
    margin: "0",
    padding: "0",
    "& > li": {
      position: "relative",
      display: "block",
      alignItems: "center",
      marginBottom: "0",
      padding: "0",
      marginLeft: "-8px",
      "& img": {
        margin: "0",
      },
    },
    userNameDT: {
      position: "relative",
      display: "block",
      fontSize: "12px",
      fontWeight: "700",
      wordBreak: "break-all",
    },
    userName: {
      fontSize: "12px !important",
      fontWeight: "700 ",
      margin: "0 0 7px !important",
    },
    userDT: {
      fontSize: "12px !important",
      fontWeight: "600 !important",
      margin: "0 !important",
    },
  },
  DPconnector: {
    top: "33px",
    left: "30px",
    width: "50px",
    position: "absolute",
    borderLeft: "1px solid #e94177",
    borderBottom: "1px solid #e94177",
    borderRadius: "0 0 0 7px",
    bottom: "20%",
  },
  togglePinnedMsg: {
    "& img": {
      transition: "0.3s",
    },
    "&.togglePin img": {
      transition: "0.3s",
      transform: "rotateZ(-90deg)",
    },
  },
  communityHeaderContainer: {
    position: "relative",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "0 15px",
    width: "100%",
    whiteSpace: "nowrap",
    "& p": {
      paddingRight: "8px",
    },
    "@media(max-width:480px)": {
      flexWrap: "wrap",
      flexDirection: "column-reverse",
      alignContent: "flex-start",
      alignItems: "flex-end",
    },
  },
  fantigerCoins: {
    position: "relative",
    display: "flex",
    alignItems: "center",
    // marginLeft: "35%",
    "& > div img": {
      position: "relative",
      top: "-2px",
      left: "5px",
    },
    "& > img": {
      position: "relative",
      top: "1px",
      left: "5px",
    },
    "@media(max-width:480px)": {
      height: "46px",
      width: "100%",
      justifyContent: "flex-end",
    },
  },
  walletCoins: {
    position: "relative",
    display: "flex",
    alignItems: "center",
    background: "#F5F5F5",
    borderRadius: "4px",
    minWidth: "80px",
    padding: "5.5px 6px",
    height: "28px",
    lineHeight: "28px",
    "&:before": {
      content: "''",
      position: "absolute",
      top: "4px !important",
      left: "0",
      width: "100%",
      zIndex: "-1",
      height: "100%",
      background:
        "linear-gradient(90.48deg, #E14084 3.73%, #3454FA 53.09%, #54B5BB 96.58%)",
      borderRadius: "4px",
    },
    "& img": {
      marginRight: "8px",
    },
  },
  fantiger_info: {
    position: "relative",
    display: "block",
    width: "100%",
    maxWidth: "812px",
    background: "#fff",
    overflow: "auto",
    margin: "auto",
    padding: "40px 40px",
    borderRadius: "20px",
    top: "50%",
    transform: "translateY(-50%)",
    "@media(max-width:767px)": {
      width: "90%",
      maxHeight: "515px",
      padding: "15px",
    },
  },
  stageChannel: {
    position: "relative",
    display: "block",
    width: "100%",
    maxWidth: "512px",
    background: "#54B5BB",
    overflow: "auto",
    margin: "auto",
    padding: "40px 40px",
    borderRadius: "20px",
    top: "50%",
    transform: "translateY(-50%)",
    "@media(max-width:767px)": {
      width: "90%",
      maxHeight: "515px",
      padding: "15px",
    },
  },

  close: {
    zIndex: "2",
    position: "absolute",
    top: "15px",
    right: "15px",
  },
  title: {
    marginBottom: "10px !important",
    marginTop: "15px !important",
    fontSize: "24px !important",
    fontWeight: "600 !important",
    "@media(max-width:767px)": {
      marginBottom: "15px",
    },
  },
  title1: {
    marginBottom: "6px !important",
    fontSize: "20px !important",
    fontWeight: "600 !important",
    "& h5": {
      marginTop: "0",
    },
  },
  description: {
    fontSize: "14px !important",
    lineHeight: "21px",
    marginBottom: "2px",
    width: "100%",
    maxWidth: "690px",
    "& p": {
      marginBottom: "0px",
    },
    "& ol": {
      textAlign: "left",
    },
    "& ol li": {
      marginBottom: "20px",
    },
    "@media(max-width:767px)": {
      maxHeight: "250px",
      overflow: "auto",
    },
  },
  secondtitlepoint: {
    paddingLeft: "15px !important",
    "& li": {
      display: "list-item",
      listStyleType: "disc !important",
      padding: "0",
    },
  },
  topLeaderborad: {
    textAlign: "center",
    fontWeight: "600",
    marginRight: "10px !important",
    fontSize: "14px",
    background: "linear-gradient(90.78deg, #B237F6 3.91%, #E94177 96.03%)",
    borderRadius: "8px !important",
    height: "40px",
    color: "#fff !important",
    textDecoration: "none",
    textTransform: "none !important",
    marginBottom: "20px",
    display: "block",
    position: "relative",
    "& img": {
      marginRight: "5px",
    },
    "@media (max-width:767px)": {
      width: "240px",
    },
  },
  topLeaderboradBox: {
    padding: "14px 0 0",
    width: "100%",
    "@media (max-width:767px)": {
      padding: "0 15px",
    },
  },
  topLeaderboradtable: {
    color: "black",
    fontSize: "18px",
    fontWeight: "500",
    borderRadius: "20px",
    borderCollapse: "collapse",
    marginBottom: "40px",
    border: "1px solid rgba(255,255,255,0.5)",
    "& tr:nth-child(even)": {
      background: "rgba(255, 255, 255, 0.1)",
    },
    "& thead th": {
      padding: "24px 0",
      border: "1px solid rgba(255,255,255,0.5)",
      borderCollapse: "collapse",
      textAlign: "center",
      fontSize: "16px",
      fontWeight: "600",
      background: "rgba(255, 255, 255, 0.1)",
    },
    "& thead th:first-child": {
      textAlign: "left",
    },
    "& tbody td": {
      padding: "10px 16px 10px 16px",
      border: "1px solid rgba(255,255,255,0.5)",
      borderCollapse: "collapse",
      textAlign: "center",
      fontSize: "18px",
      color: "#fff",
      // minHeight:"94px",
    },
  },
  gridHead: {
    position: "relative",
    display: "grid",
    gridTemplateColumns: "40% 40% 20%",
    "& > span": {
      padding: "0 15px",
    },
  },
  gridHeadRows: {
    position: "relative",
    display: "grid",
    gridTemplateColumns: "40% 40% 20%",
    marginBottom: "2px",
    "&:before": {
      content: "''",
      position: "absolute",
      zIndex: "-2",
      left: "-2px",
      top: "-2px",
      right: "-2px",
      bottom: "-2px",
      borderRadius: "10px",
      visibility: "hidden",
      opacity: "0",
      transition: "0.3s",
      background:
        "linear-gradient(90.48deg, #E14084 3.73%, #3454FA 53.09%, #54B5BB 96.58%)",
    },
    "&:after": {
      content: "''",
      position: "absolute",
      zIndex: "-1",
      left: "0",
      top: "0",
      right: "0",
      bottom: "0",
      background: "#fff",
      borderRadius: "10px",
      overflow: "hidden",
    },
    "&:hover:before": {
      visibility: "visible",
      opacity: "1",
      transition: "0.3s",
    },
    "&> div": {
      padding: "0 15px",
    },
  },
}));

const CommunityChannel = ({
  isMobile,
  openThreadPopup,
  channel,
  community,
  goTo,
}) => {
  const classes = useStyles();
  const [anchorEl2, setAnchorEl2] = React.useState(null);
  const userEmailId = localStorage.getItem("userEmailID");
  const [show, threadShow] = useState(false);
  const threadPopupOpen = (event) => {
    songPageGTMCTAClick(
      r,
      "Threads",
      currentCommunityState?.attributes?.community_name,
      "Threads",
      "loggedIn",
      "Guest"
    );
    setAnchorEl2(event.currentTarget);
    console.log("community", community, channel, event);
    showThreadList({ communityid: community, channelid: channel });
    threadShow(true);
    dispatch(setShowAllThreads(false));
  };

  const {
    showAllThreads,
    refresh,
    displayRightPinnedThread,
    unreadMessageNotifications,
    threadUnreadNotifications,
  } = useSelector((state) => state.community);

  const dispatch = useDispatch();
  const router = useRouter();
  const [anchorEl, setAnchorEl] = useState(null);
  const [open, setOpen] = useState(false);
  const [open2, setOpen2] = useState(false);
  const [channelShow, setChannelShow] = useState("");
  const [currentChannel, setCurrentChannel] = useState(null);
  const [channels, setChannels] = useState([]);
  const [threadListlength, setThreadListlength] = useState(0);
  const [threadList, setThreadList] = useState([]);
  const [displayPinnedMessage, setDisplayPinnedMessage] = useState(true);
  const userRole = localStorage.getItem("userRole");
  const { userData } = useSelector((state) => state.user);
  const commonContext = useContext(CommonContext);
  const [displayTopcontributer, setDisplayTopcontributer] = useState([]);

  const handleClose2 = () => {
    setOpen2(false);
  };

  const handleOpen2 = () => {
    setOpen2(true);
  };
  const { country_code } = useSelector((state) => state.layout);

  const channelsCommunityState = useSelector(
    (state) => state.community.channels
  );
  const currentChannelCommunityState = useSelector(
    (state) => state.community.currentChannel
  );
  const currentCommunityState = useSelector((state) => state.community.current);

  const threadPopupClose = () => {
    threadShow(false);
    setAnchorEl2(null);
    dispatch(setShowAllThreads(false));
  };

  const { mutate: getThreadUnreadCounts } = useMutation(
    (id) => fetcher.get(`/v1/user/last-seen?channelId=${id}`),
    {
      onSuccess: (response) => {
        dispatch(setThreadUnreadNotifications(response?.result));
      },
      onError: (error) => {
        console.log("error", error);
      },
    }
  );

  useEffect(() => {
    if (currentChannelCommunityState) {
      dispatch(setThreadUnreadNotifications([]));
      getThreadUnreadCounts(currentChannelCommunityState?._id);
    }
  }, [currentChannelCommunityState]);

  useEffect(() => {
    if (showAllThreads) {
      threadPopupOpen({ currentTarget: "#threadButton" });
    }
  }, [showAllThreads]);

  const getChannelsUnreadCount = async () => {
    if (channelsCommunityState.length) {
      let response = await getCommunityUnreadMessagCountList(
        channelsCommunityState
      );
      if (response?.length) {
        let unreadsList = [...unreadMessageNotifications];
        for (let i = 0; i < response.length; i++) {
          let channelItem = response[i];
          if (channelItem) {
            const unreadItem = unreadsList.filter(
              (item) => item?.channelId == channelItem?.channelId
            );
            if (unreadItem?.length) {
              let indexOfChannelItem = unreadsList.indexOf(unreadItem[0]);
              unreadsList[indexOfChannelItem] = {
                ...unreadItem[0],
                ...channelItem,
              };
            }
          }
        }
        dispatch(setUnreadMessageNotifications(unreadsList));
      }
    }
  };

  useEffect(() => {
    if (channelsCommunityState) {
      getChannelsUnreadCount(channelsCommunityState);
      setChannelShow("");
      setChannels(channelsCommunityState);
      const _index = channelsCommunityState.findIndex(
        (obj) => obj._id == currentChannelCommunityState._id
      );
      if ((isMobile && _index > 0) || (!isMobile && _index > 1)) {
        setChannelShow(currentChannelCommunityState.name);
      }
    }
  }, [channelsCommunityState]);
  useEffect(() => {
    if (currentChannelCommunityState) {
      setCurrentChannel(currentChannelCommunityState);
      dispatch(setChannelMessageList([]));
    }
  }, [currentChannelCommunityState]);

  const handleSelectChannel = (e, item) => {
    e.preventDefault();
    songPageGTMCTAClick(
      r,
      item?.name,
      currentCommunityState?.attributes?.community_name,
      item?.name,
      "loggedIn",
      "Guest"
    );
    setChannelShow("");
    console.log("channel item is \n ", item);
    dispatch(setCommunityCurrentChannel(item));
    router.push(
      `/community/${currentCommunityState.id}/${item._id}`,
      undefined,
      {
        shallow: true,
      }
    );
  };
  const handleSelectMoreChannel = (e, item) => {
    e.preventDefault();
    setOpen(false);
    setChannelShow(item?.name);
    dispatch(setCommunityCurrentChannel(item));
    router.push(
      `/community/${currentCommunityState.id}/${item._id}`,
      undefined,
      {
        shallow: true,
      }
    );
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    setOpen(true);
  };
  const handleClose = () => {
    setAnchorEl(null);
    setOpen(false);
  };

  // onclick particular thread according to thread filter messages

  const createThread = () => {
    dispatch(setShowThread(true));
    dispatch(setSelectedThread(null));
    setAnchorEl2(null);
    if (isMobile) {
      goTo("member");
    }
  };
  const showThread = (item) => {
    threadShow(false);
    setAnchorEl2(null);
    dispatch(setThreadDetails({ meta: item }));
    dispatch(setShowThread(true));
    if (item) {
      if (item?._id) dispatch(setSelectedThread(item._id));
      else {
        dispatch(setSelectedThread(null));
      }
    } else {
      dispatch(setSelectedThread(null));
    }
    if (isMobile) {
      goTo("member");
    }
  };

  // get thread list
  const { mutate: showThreadList } = useMutation(
    ({ communityid, channelid }) =>
      fetcher.get(
        `/v1/community/${communityid}/community-channel/${channelid}/thread?limit=100`
      ),
    {
      onSuccess: (res) => {
        setThreadList(res.result.reverse());
        // const filterFinalThread = res?.result.filter(
        //   (item) =>
        //     // item?.messageDetails?.totalCount != 1 &&
        //     item?.messageDetails?.lastMessage?.type == "predictor"
        // );
        // console.log("Print Thread List for userName: ", filterFinalThread);
        //
        setThreadListlength(res?.result?.length);
      },
      onError: (error) => {
        console.log("error occured ==", error);
      },
    }
  );
  // Pin message
  const [pinMessageList, setGetpinMessageList] = useState([]);
  const { mutate: pinMsg } = useMutation(
    () => fetcher.get(`/v1/message?channelId=${channel}&isPinned=true`),
    {
      onSuccess: (res) => {
        setGetpinMessageList(res?.result);
        if (res?.result?.length && !isMobile) {
          if (res?.result[0]?.pinPosition == "right") {
            if (
              res?.result[0]?.threadDetails?.meta?._id !=
              displayRightPinnedThread
            ) {
              showThread(res?.result[0]?.threadDetails?.meta);
              dispatch(
                setDisplayRightPinnedThread(
                  res?.result[0]?.threadDetails?.meta?._id
                )
              );
              dispatch(
                setRightPinnedThreadDetails({
                  meta: res?.result[0]?.threadDetails?.meta,
                })
              );
              setItem(false);
            }
          } else {
            dispatch(setShowThread(false));
            dispatch(setDisplayRightPinnedThread(false));
            dispatch(setRightPinnedThreadDetails(null));
          }
        }
      },
      onError: (error) => {
        console.log("Print Error Message ==", error);
      },
    }
  );

  useEffect(() => {
    if (channel) {
      setDisplayPinnedMessage(true);
      pinMsg();
    }
  }, [channel, refresh]);

  const [item, setItem] = useState(false);

  useEffect(() => {
    if (pinMessageList?.length > 0) {
      if (pinMessageList[0]?.pinPosition == "top") {
        setItem(pinMessageList[0]);
      } else {
        if (pinMessageList[0]?.pinPosition != "top" && isMobile) {
          setItem(pinMessageList[0]);
        }
      }
    } else {
      dispatch(setShowThread(false));
      dispatch(setDisplayRightPinnedThread(false));
      dispatch(setRightPinnedThreadDetails(null));
    }
  }, [pinMessageList]);

  const getUserImg = (name) => {
    if (name) {
      let arr = name?.split(" ");
      if (arr.length > 1) {
        return (
          arr[0]?.toUpperCase()?.substring(0, 1) +
          arr[1]?.toUpperCase()?.substring(0, 1)
        );
      } else {
        return arr[0]?.toUpperCase()?.substring(0, 2);
      }
    }
    return "";
  };

  const ProfileIcon = (props) => {
    return (
      <Box component="div">
        {props.profilePic && (
          <div className={"obj_img"}>
            <Image alt="" src={props.profilePic} layout="fill" />
          </div>
        )}
        {!props.profilePic && (
          <div
            style={{ background: "#54b5bb", color: "#FFF" }}
            className={"obj_img"}
          >
            {getUserImg(props.name)}
          </div>
        )}
      </Box>
    );
  };

  const openThreadSideView = (item) => {
    dispatch(setThreadDetails(item));
    dispatch(setSelectedThread(item?.meta?._id));
    dispatch(setShowThread(true));
    dispatch(setShowAllThreads(false));
  };

  const getMessageSubstr = (msg) => {
    if (typeof msg != "undefined") {
      if (isMobile) {
        let len = 15;
        if (msg.length > len) {
          let msgTextArr = msg.substring(0, len).lastIndexOf(" ");
          return (
            msg.substring(0, msgTextArr >= 0 ? msgTextArr + 1 : len) + "..."
          );
        } else {
          return msg;
        }
      } else {
        let len = 110;
        if (msg.length > len) {
          let msgTextArr = msg.substring(0, len).lastIndexOf(" ");
          return (
            msg.substring(0, msgTextArr >= 0 ? msgTextArr + 1 : len) + "..."
          );
        } else {
          return msg;
        }
      }
    } else return msg;
  };

  const getChannelUnreadMessageCount = (list, channelId) => {
    if (list?.length) {
      let channelUnread = list.filter((item) => item?.channelId == channelId);
      return channelUnread?.length ? channelUnread[0].count : 0;
    }
    return 0;
  };

  const getTotalThreadUnreadCount = (totalUnreadList) => {
    let list = [];
    list = totalUnreadList.filter((item) =>
      Object.hasOwn(item, "lastSeenMessageTimestamp")
    );

    if (list?.length) {
      let total = list?.reduce((sum, item) => sum + item?.unreadCount, 0);
      if (total > 100) {
        return "100+";
      } else if (total > 0) return total + "";

      return "";
    }
    return "";
  };

  const getThreadNewMessageCount = (threadId) => {
    if (threadUnreadNotifications?.length) {
      let threadItem = threadUnreadNotifications.filter(
        (item) => item?.threadId == threadId
      );
      if (threadItem?.length) {
        return Object.hasOwn(threadItem[0], "lastSeenMessageTimestamp")
          ? threadItem[0]?.unreadCount
          : 0;
      }
      return 0;
    }
    return 0;
  };

  let threadTotalUnreadCount = getTotalThreadUnreadCount(
    threadUnreadNotifications
  );

  const { mutate: unpinMessage } = useMutation(
    (data) =>
      fetcher.post(`/v1/message/${data.messageId}/pin`, {
        channelId: data?.channelId,
        isPinned: false,
      }),
    {
      onSuccess: (response) => {
        console.log("response ", response);
        setDisplayPinnedMessage(false);
      },
      onError: (error) => {
        console.log("error: ", error);
      },
    }
  );

  // Top Leader details
  const r = auth();

  const { mutate: getTopLeaderuser } = useMutation(
    () => fetcher.get(`v1/community/leader-board`),
    {
      onSuccess: (response) => {
        console.log("Print response: ", response?.data);
        setDisplayTopcontributer(response?.data);
      },
      onError: (error) => {
        console.log("error: ", error);
      },
    }
  );

  useEffect(() => {
    getTopLeaderuser();
  }, []);

  // console.log("Print item for message:", item);

  const [pinMsgcreateTime, setPinMsgcreateTime] = useState();

  useEffect(() => {
    setPinMsgcreateTime(item?.createdAt);
  }, [item]);

  // console.log("Print pinMsgcreateTime:", pinMsgcreateTime);

  const [pages, setPages] = useState(0);
  const [listmessage, setListMessage] = useState([]);

  const { mutate: filterMessage } = useMutation(
    (data) =>
      fetcher.get(`/v1/message?page=${pages}&channelId=${data.channelId}`),
    {
      onSuccess: (response) => {
        console.log("Print response: ", response);
        setPages(response?.page);
        setListMessage(response?.result);
        if (response?.result.length) {
          const messagefilter = response?.result?.filter((item) => {
            item?.createdAt === pinMsgcreateTime;
          });
          console.log("item Print response:", messagefilter);
        }
      },
      onError: (error) => {
        console.log("error: ", error);
      },
    }
  );

  const [open1, setOpen1] = useState(false);

  const handleClose1 = () => {
    setOpen1(false);
  };

  return (
    <Box>
      <Box className={classes.communityHeaderContainer}>
        <ul className="channel_list">
          {channels &&
            channels?.length > 0 &&
            channels?.map((item, index) => {
              let unreadNotification = getChannelUnreadMessageCount(
                unreadMessageNotifications,
                item?._id
              );

              return (
                index < (isMobile ? 3 : 3) && (
                  <li
                    key={index}
                    className={
                      currentChannel && currentChannel._id == item?._id
                        ? "active"
                        : ""
                    }
                  >
                    <a
                      href=""
                      onClick={(e) => handleSelectChannel(e, item)}
                      style={{ flexDirection: "row", display: "flex" }}
                    >
                      {item?.name}

                      {unreadNotification && currentChannel._id != item?._id ? (
                        <Box
                          sx={{
                            background: "#E14084",
                            height: "22px",
                            padding: "4px 8px 0px 8px",
                            borderRadius: "15px",
                            margin: "-10px 0px 0px 0px",
                          }}
                        >
                          <Typography
                            sx={{
                              color: "#FFF",
                              fontSize: "12px",
                              fontWeight: "500",
                              lineHeight: "14px",
                            }}
                          >
                            {unreadNotification}
                          </Typography>
                        </Box>
                      ) : (
                        <></>
                      )}
                    </a>
                  </li>
                )
              );
            })}
          {/* {channelShow && (
            <li className={"nav-item active"} key={100}>
              <a
                href=""
                onClick={(e) => {
                  e.preventDefault();
                }}
              >
                {channelShow}
              </a>
            </li>
          )} */}
          <li style={{ position: "relative", display: "block" }}>
            <a href="#" onClick={threadPopupOpen} id={"#threadButton"}>
              <span style={{ display: "flex", flexDirection: "row" }}>
                Threads{" "}
                {threadTotalUnreadCount ? (
                  <Box
                    sx={{
                      background: "#E14084",
                      height: "22px",
                      padding: "4px 8px 0px 8px",
                      borderRadius: "15px",
                      margin: "-10px 0px 0px 0px",
                    }}
                  >
                    <Typography
                      sx={{
                        color: "#FFF",
                        fontSize: "12px",
                        fontWeight: "500",
                        lineHeight: "14px",
                      }}
                    >
                      {threadTotalUnreadCount}
                    </Typography>
                  </Box>
                ) : (
                  <></>
                )}
              </span>
            </a>
            {/* =========No Thread/Create Thread PopUp Start */}
            <Popover
              id="simple-menu"
              anchorEl={anchorEl2}
              keepMounted
              open={Boolean(anchorEl2)}
              onClose={threadPopupClose}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "center",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "center",
              }}
            >
              {threadListlength ? (
                <>
                  {
                    <Box className={classes.modalContainer}>
                      <Typography
                        className={classes.popupTitle}
                        variant="h4"
                        style={{ fontWeight: "600" }}
                      >
                        Threads
                      </Typography>
                      {/* <Link className={classes.btnSearch}>
                        <Box className={classes.inputContainer}>
                          <Slide in={inputShow} direction="left" unmountOnExit>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Search Here..."
                            />
                          </Slide>
                        </Box>
                        <Box
                          component="img"
                          src="/images/community/search.svg"
                          onClick={showInput}
                          width="24"
                          height="24"
                        />
                      </Link> */}
                      <Link
                        className={classes.btnClose}
                        onClick={threadPopupClose}
                      >
                        <Box
                          component="img"
                          src="/images/community/close.svg"
                          width="24"
                          height="24"
                        />
                      </Link>
                      <Box className={classes.contentContainer}>
                        <List className={classes.threadList}>
                          {threadList.map((list, key) => {
                            let threadUnreadCount = getThreadNewMessageCount(
                              list?._id
                            );

                            // console.log(
                            //   "Print threadList total number: ",
                            //   list
                            // );
                            return (
                              <>
                                <ListItem
                                  key={key}
                                  onClick={() => {
                                    showThread(list);
                                  }}
                                  sx={{
                                    cursor: "pointer",
                                    marginBottom: "20px",
                                  }}
                                >
                                  <Box>
                                    <Box className={classes.threadTitle}>
                                      <Box
                                        component="img"
                                        src="/images/community/hashChat.png"
                                        width="19px"
                                        height="19px"
                                      />
                                      <Typography variant="h5">
                                        {list.name}
                                      </Typography>
                                      {list?.messageDetails &&
                                      threadUnreadCount ? (
                                        <Typography
                                          variant="span"
                                          sx={{ fontSize: "14px !important" }}
                                        >
                                          {threadUnreadCount} Unread messages
                                        </Typography>
                                      ) : (
                                        <Typography
                                          variant="span"
                                          sx={{ fontSize: "14px !important" }}
                                        >
                                          Join the conversation
                                        </Typography>
                                      )}
                                    </Box>
                                    <Box className={classes.threadCreatedBy}>
                                      <ProfileIcon
                                        profilePic={list?.user?.profilePic}
                                        name={list?.user?.name}
                                        outerClass={"user_img"}
                                        innerClass={"user_img_inner"}
                                      />

                                      <Typography variant="h5">
                                        {list?.user?.name}:
                                      </Typography>
                                      <Typography variant="span">
                                        Created
                                      </Typography>
                                      <Typography variant="span">
                                        {moment(list?.createdAt).fromNow()}
                                      </Typography>
                                    </Box>
                                  </Box>
                                  {/* <Box className={classes.thumbListContainer}>
                                    <List className={classes.thumbList}>
                                      <ListItem>
                                        {" "}
                                        <Box
                                          component="img"
                                          src="/images/community/profile-thumbnail.png"
                                          width="19px"
                                          height="19px"
                                        />
                                      </ListItem>
                                      <ListItem>
                                        {" "}
                                        <Box
                                          component="img"
                                          src="/images/community/profile-thumbnail-2.png"
                                          width="19px"
                                          height="19px"
                                        />
                                      </ListItem>
                                    </List>
                                  </Box> */}
                                </ListItem>
                              </>
                            );
                          })}
                        </List>
                        {userEmailId == "admin@fantiger.com" && (
                          <Button
                            className={classes.btnCreateThread}
                            onClick={() => {
                              createThread();
                            }}
                            contained="solid"
                          >
                            Create Thread
                          </Button>
                        )}
                      </Box>
                    </Box>
                  }
                </>
              ) : (
                <Box className={classes.modalContainer}>
                  <Typography className={classes.popupTitle} variant="h4">
                    Threads
                  </Typography>
                  <Link onClick={threadPopupClose} className={classes.btnClose}>
                    <Box
                      component="img"
                      src="/images/community/close.svg"
                      width="24"
                      height="24"
                    />
                  </Link>
                  <Box className={classes.contentContainer}>
                    <Box
                      component="img"
                      src="/images/community/hand.svg"
                      width="36"
                      height="44"
                    />
                    <Typography variant="h4">Hey, There</Typography>
                    <Typography component="p">There are no threads.</Typography>
                    {userEmailId == "admin@fantiger.com" && (
                      <Button
                        className={classes.btnCreateThread}
                        onClick={() => createThread()}
                        contained="solid"
                      >
                        Create Thread
                      </Button>
                    )}
                  </Box>
                </Box>
              )}
            </Popover>
            {/* =========No Thread/Create Thread PopUp Close */}
          </li>

          {/* Add FanTiger Coin */}

          {/* {channels && channels?.length > (isMobile ? 1 : 2) && (
            <li>
              <div
                className="dropdown-toggle"
                style={{ cursor: "pointer" }}
                onClick={handleClick}
              >
                More
              </div>
              <Menu
                id="basic-menu"
                className="more_channel"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                  "aria-labelledby": "basic-button",
                }}
                transformOrigin={{ horizontal: "left", vertical: "top" }}
                anchorOrigin={{ horizontal: "left", vertical: "bottom" }}
              >
                {channels?.map(
                  (item, i) =>
                    i > (isMobile ? 0 : 1) && (
                      <MenuItem
                        onClick={(e) => handleSelectMoreChannel(e, item)}
                        key={`channel${i}`}
                      >
                        <img src="/images/community/headefone.svg" alt="" />
                        {item?.name}
                      </MenuItem>
                    )
                )}
              </Menu>
            </li>
          )} */}
        </ul>

        <Box style={{ display: "flex", alignItems: "center" }}>
          <Button
            className={classes.topLeaderborad}
            onClick={() => {
              handleOpen2();
            }}
          >
            <img src="/images/payment/trophy-fill.svg" /> Top Contributor
          </Button>
          <Box className={classes.fantigerCoins}>
            <Box className={classes.walletCoins}>
              <img src="/images/community/fantigercoin.svg" />
              <Typography variant="p">
                {Math.round(commonContext?.fantigerCoin)}
              </Typography>
            </Box>
            <Box
              component="img"
              src="/images/community/info.svg"
              style={{ cursor: "pointer" }}
              onClick={() => {
                setOpen1(true);
              }}
            />
          </Box>
        </Box>
      </Box>

      <div className="pinned-comment" style={{ backgroundColor: "#f4f5fd" }}>
        <Typography variant="p" style={{ fontSize: "10px", fontWeight: "500" }}>
          {pinMessageList?.length && item && displayPinnedMessage ? (
            <>
              {item?.isPinned == true && item?.isThread == true ? (
                <>
                  <Typography
                    variant="span"
                    className={classes.togglePinnedMsg}
                    sx={{
                      cursor: userData?.role == "admin" ? "pointer" : "default",
                    }}
                    onClick={() => {
                      if (userData?.role == "admin")
                        unpinMessage({
                          channelId: currentChannel?._id,
                          messageId: item?._id,
                        });
                    }}
                  >
                    <img
                      src="/images/community/thumb-pin.svg"
                      style={{
                        width: "8px",
                        marginRight: "5px",
                      }}
                    />
                    Pinned Thread
                  </Typography>
                  {/* <Box style={{ display: "flex", marginLeft: "-11px" }}>
                <Box
                  width="35px"
                  height="35px"
                  borderRadius={"25px"}
                  backgroundColor="#54b5bb"
                  sx={{
                    justifyContent: "center",
                    alignItems: "center",
                    display: "flex",
                    marginRight: "14px",
                    color: "#FFF",
                  }}
                >
                  {getPinmsg[0]?.user?.name.substring(0, 2).toUpperCase()}
                </Box>
                <Box className={classes.userNameDT}>
                  <Typography
                    variant="p"
                    // className={classes.userName}
                    style={{
                      fontSize: "12px",
                      fontWeight: "700",
                    }}
                  >
                    {getPinmsg[0]?.user?.name}
                  </Typography>
                  <Typography
                    variant="p"
                    // className={classes.userDT}
                    style={{
                      fontSize: "12px",
                      display: "block",
                    }}
                  >
                    {getPinmsg[0]?.text}
                  </Typography>
                  <Box fontSize="14px">
                    <small className="user_dt">
                      {moment(getPinmsg[0]?.createdAt).fromNow()}
                    </small>
                  </Box>
                </Box>
              </Box> */}
                  <div
                    className="message_wrap poll_message_wrapper"
                    style={{
                      background: item?.bgColor ? item?.bgColor : "",
                      padding: "0",
                      marginLeft: "-25px",
                    }}
                  >
                    <div className="poll-container">
                      <div className="user_action_info">
                        <div className="user_info">
                          <ObjectIconImg
                            profilePic={item?.user?.profilePic}
                            name={item?.user?.name}
                            outerClass={"user_img"}
                            innerClass={"user_img_inner"}
                          />

                          {/* <img
                              src="/images/community/connector.svg"
                              className={classes.DPconnector}
                              width="43"
                              height="43"
                            /> */}
                        </div>
                      </div>
                      <div className="poll-creator">
                        <span className={classes.DPconnector}></span>
                        {/* <p>
                            <span>{item?.user?.name}</span> started a new thread
                            :{" "}
                            <strong>
                              {" "}
                              {item?.threadDetails?.meta?.name.length > 40
                                ? item?.threadDetails?.meta?.name.substring(
                                    0,
                                    0
                                  ) + "..."
                                : item?.threadDetails?.meta?.name}
                            </strong>{" "}
                            <Link
                              onClick={() => {
                                dispatch(setShowAllThreads(true));
                              }}
                              style={{ cursor: "pointer", color: "blue" }}
                            >
                              See all Threads
                            </Link>
                          </p> */}
                        {/* {item?.type === "text" &&
                            item?.text != item?.threadDetails?.meta?.name && (
                              <p>{item?.text}</p>
                            )}
                          <small>
                            {moment(item?.createdAt).format("HH:MM A")}
                          </small> */}

                        <List className={classes.threadList}>
                          <ListItem>
                            <Box>
                              <Box
                                className={classes.threadTitle}
                                sx={{ cursor: "pointer" }}
                                onClick={() => {
                                  openThreadSideView(item?.threadDetails);
                                  if (isMobile) {
                                    goTo("member");
                                  }
                                }}
                              >
                                <Box
                                  component="img"
                                  src="/images/community/hashChat.svg"
                                  width="18"
                                  height="18"
                                />
                                <Typography variant="h5">
                                  {isMobile
                                    ? item?.threadDetails?.meta?.name?.substring(
                                        0,
                                        12
                                      ) + "..."
                                    : item?.threadDetails?.meta?.name}
                                </Typography>
                                <Typography variant="span">
                                  <Link
                                    href="#"
                                    style={{
                                      textDecoration: "none",
                                      fontSize: "16px !important",
                                    }}
                                  >
                                    {item?.threadDetails?.message
                                      ?.totalCount ? (
                                      <span
                                        sx={{
                                          textDecoration: "none",
                                          fontSize: "16px !important",
                                          color: "yellow",
                                        }}
                                      >
                                        {
                                          item?.threadDetails?.message
                                            ?.totalCount
                                        }{" "}
                                        {item?.threadDetails?.message
                                          ?.totalCount > 1
                                          ? "Messages "
                                          : "Message "}
                                      </span>
                                    ) : (
                                      <></>
                                    )}
                                    <Box
                                      component="img"
                                      src="/images/community/angle-arrow-right.svg"
                                      width="10px"
                                      height="10px"
                                    />
                                  </Link>
                                </Typography>
                              </Box>
                              {item?.threadDetails?.message?.totalCount ? (
                                <Box className={classes.threadCreatedBy}>
                                  <Typography variant="span">
                                    {
                                      item?.threadDetails?.message?.lastMessage
                                        ?.user?.name
                                    }
                                  </Typography>
                                  <Typography variant="h5">
                                    {getMessageSubstr(
                                      item?.threadDetails?.message?.lastMessage?.text.replaceAll(
                                        "***",
                                        ""
                                      )
                                    )}
                                  </Typography>
                                  <Typography variant="h5">
                                    {moment(
                                      item?.threadDetails?.message?.lastMessage
                                        ?.createdAt
                                    ).format("HH:MM A")}
                                  </Typography>
                                </Box>
                              ) : (
                                <></>
                              )}
                            </Box>
                          </ListItem>
                        </List>
                      </div>
                    </div>
                  </div>
                </>
              ) : (
                <>
                  <Typography
                    variant="span"
                    className={classes.togglePinnedMsg}
                    sx={{
                      cursor: userData?.role == "admin" ? "pointer" : "default",
                    }}
                    onClick={() => {
                      if (userData?.role == "admin")
                        unpinMessage({
                          channelId: currentChannel?._id,
                          messageId: item?._id,
                        });
                    }}
                  >
                    <img
                      src="/images/community/thumb-pin.svg"
                      style={{
                        width: "8px",
                        marginRight: "5px",
                      }}
                    />
                    Pinned Message
                  </Typography>
                  <div
                    className="message_wrap poll_message_wrapper"
                    style={{
                      background: item?.bgColor ? item?.bgColor : "",
                      padding: "0",
                      marginLeft: "-25px",
                    }}
                  >
                    <div className="poll-container">
                      <div className="user_action_info">
                        <div className="user_info">
                          <ObjectIconImg
                            profilePic={item?.user?.profilePic}
                            name={item?.user?.name}
                            outerClass={"user_img"}
                            innerClass={"user_img_inner"}
                          />
                        </div>
                      </div>
                      <div className="poll-creator">
                        <span className={classes.DPconnector}></span>

                        <List
                          className={classes.threadList}
                          onClick={() => {
                            if (userData?.role == "admin") {
                              filterMessage({
                                channelId: currentChannel?._id,
                                // messageId: item?._id,
                              });
                            }
                          }}
                        >
                          <ListItem
                            sx={{
                              backgroundColor: "rgb(255, 250, 239) !important",
                            }}
                          >
                            <Box>
                              <Box className={classes.threadCreatedBy}>
                                <Typography variant="span">
                                  {item?.user?.name}
                                </Typography>
                                <Typography variant="h5">
                                  {getMessageSubstr(
                                    item?.text.replaceAll("***", "")
                                  )}
                                </Typography>
                                <Typography variant="h5">
                                  {moment(item?.createdAt).fromNow()}
                                </Typography>
                              </Box>

                              <Box
                                className={classes.threadTitle}
                                sx={{ cursor: "pointer" }}
                                onClick={() => {
                                  // openThreadSideView(item?.threadDetails);
                                  // if (isMobile) {
                                  //   goTo("member");
                                  // }
                                }}
                              >
                                <Box
                                  component="img"
                                  src="/images/community/hashChat.svg"
                                  width="18"
                                  height="18"
                                />
                                <Typography variant="h5">
                                  {isMobile
                                    ? item?.text.substring(0, 12) + "..."
                                    : item?.text.substring(0, 100) + "..."}
                                </Typography>
                                <Typography variant="span">
                                  <Link
                                    href="#"
                                    style={{
                                      textDecoration: "none",
                                      fontSize: "16px !important",
                                    }}
                                  >
                                    {item?.threadDetails?.message
                                      ?.totalCount ? (
                                      <span
                                        sx={{
                                          textDecoration: "none",
                                          fontSize: "16px !important",
                                          color: "yellow",
                                        }}
                                      >
                                        {
                                          item?.threadDetails?.message
                                            ?.totalCount
                                        }{" "}
                                        {item?.threadDetails?.message
                                          ?.totalCount > 1
                                          ? "Messages "
                                          : "Message "}
                                      </span>
                                    ) : (
                                      <>{/* <span>1 Message</span> */}</>
                                    )}
                                    <Box
                                      component="img"
                                      src="/images/community/angle-arrow-right.svg"
                                      width="10px"
                                      height="10px"
                                    />
                                  </Link>
                                </Typography>
                              </Box>
                            </Box>
                          </ListItem>
                        </List>
                      </div>
                    </div>
                  </div>
                </>
              )}
            </>
          ) : (
            <></>
          )}
        </Typography>
      </div>

      <Modal open={open1} onClose={handleClose1} disableScrollLock={true}>
        <Box className={classes.fantiger_info}>
          <button
            type="button"
            className={classes.close + " close"}
            data-dismiss="modal"
            aria-label="Close"
            onClick={handleClose1}
          >
            <span aria-hidden="true">
              <img src="/images/community/modal-close.svg" width="24px" />
            </span>
          </button>
          {/* first point */}

          <Box>
            <Box>
              <Typography variant="h5" className={classes.title}>
                How to Earn Coins{" "}
                <img
                  src="/images/community/fantigercoin.svg"
                  style={{ width: "24px", height: "24px" }}
                />{" "}
                :
              </Typography>
              <Box className={classes.description}>
                <Typography variant="p">
                  Users can earn FanTiger coins by doing various activities as
                  listed below.<br></br>{" "}
                  {/* <i style={{ fontWeight: "600" }}>
                    Special Bonus Offer : DOUBLE THE COIN SCHEME APPLICABLE ONLY
                    FROM 17th Aug 2022 till 15th Sep 2022.
                  </i> */}
                </Typography>
              </Box>
            </Box>
          </Box>

          {/* second point */}
          <Box>
            <Typography variant="h5" className={classes.title1}>
              Engagement :
            </Typography>

            <Box className={classes.description}>
              <List className={classes.secondtitlepoint}>
                <ListItem>20 Coin - per reaction</ListItem>
                <ListItem>
                  50 Coin - One word message (repeat not allowed)
                </ListItem>
                <ListItem>
                  100 Coin - for sentence in the range of 2 to 8 words
                </ListItem>
                <ListItem>
                  150 Coin - for sentence greater than 8 words
                </ListItem>
                <ListItem>200 Coin - for joining in live events</ListItem>
                <ListItem>
                  1000 Coin - for staying in the event for &gt; 50% of the
                  duration
                </ListItem>
              </List>
            </Box>
          </Box>

          {/* Third point */}
          <Box>
            <Typography variant="h5" className={classes.title1}>
              Purchase / Referral :
            </Typography>

            <Box className={classes.description}>
              <List className={classes.secondtitlepoint}>
                <ListItem>20% Cashback Coins : Referral Program*</ListItem>
                <ListItem> 500 Coin - Community Invite Program*</ListItem>
              </List>
            </Box>
          </Box>

          {/* fourth point */}
          <Box>
            <Typography variant="h5" className={classes.title}>
              How to Use Coins :
            </Typography>
            <Box className={classes.description}>
              <List className={classes.secondtitlepoint}>
                <ListItem>Coins can be redeemed for</ListItem>
                <ListItem>Future NFT purchases</ListItem>
                <ListItem>
                  Can be converted to FanTiger Tokens when launched (conversion
                  to be decided by FanTiger Management)
                </ListItem>
              </List>
            </Box>
          </Box>
          <Typography
            variant="span"
            style={{ marginTop: "37px !important", fontWeight: "600" }}
          >
            * check details of Referral and Invite program in Announcements
          </Typography>
        </Box>
      </Modal>

      <Modal open={open2} onClose={handleClose2} disableScrollLock={true}>
        <Box className={classes.fantiger_info}>
          <button
            type="button"
            className={classes.close + " close"}
            data-dismiss="modal"
            aria-label="Close"
            onClick={handleClose2}
          >
            <span aria-hidden="true">
              <img src="/images/community/modal-close.svg" width="24px" />
            </span>
          </button>

          <Box>
            <Box>
              <Typography variant="h5" className={classes.title}>
                <img
                  src="/images/community/TrophyNo.gif"
                  style={{ width: "58px", height: "63px" }}
                />
                Top Contributor
              </Typography>
              <Box className={classes.description}>
                <Typography variant="p">
                  Weekly Contributor Leaderboard based on the Engagement in the
                  Community. Every week top contributor will be chosen and will
                  be rewarded.
                </Typography>
              </Box>
              <Box className={classes.topLeaderboradBox}>
                <Box className={classes.gridHead}>
                  <Typography component="span">#Rank</Typography>
                  <Typography component="span">Name</Typography>
                  <Typography component="span" style={{ paddingLeft: "25px" }}>
                    Coins
                  </Typography>
                </Box>
                {displayTopcontributer &&
                  displayTopcontributer?.map((item) => {
                    return (
                      <Box key={item.id} className={classes.gridHeadRows}>
                        <Box
                          style={{
                            display: "flex",
                            alignItems: "center",
                            color: "#000",
                          }}
                        >
                          <Box
                            component="img"
                            src={
                              item?.RANK % 2 == 0
                                ? "/images/community/colorTrophy.svg"
                                : "/images/community/trophywhite.svg"
                            }
                          />
                          <Typography component="p"> #{item?.RANK} </Typography>
                        </Box>
                        <Box
                          style={{
                            display: "flex",
                            alignItems: "center",
                            color: "#000",
                          }}
                        >
                          <Box
                            style={{
                              cursor: "pointer",
                              width: "20px",
                              height: "20px",
                            }}
                            component="img"
                            src={item?.profile_pic}
                          />
                          <Typography component="p"> {item?.name} </Typography>
                        </Box>
                        <Box
                          style={{
                            display: "flex",
                            alignItems: "center",
                            color: "#000",
                          }}
                        >
                          <Typography
                            style={{
                              cursor: "pointer",
                              width: "40px",
                              height: "40px",
                              background:
                                "center/cover no-repeat url(/images/community/CoinGif.gif)",
                            }}
                            component="span"
                          ></Typography>
                          <Typography component="p">
                            {" "}
                            {item?.totalcoin}{" "}
                          </Typography>
                        </Box>
                      </Box>
                    );
                  })}
              </Box>
            </Box>
          </Box>
        </Box>
      </Modal>
    </Box>
  );
};

export default CommunityChannel;
